<template>
  <div class="chat-container">
    <h1>WhatsApp Chat Record {{ status.loading ? `(Loading...)` : `` }}</h1>
    <p><strong>Date of Export:</strong> <span> {{MessageDateRange.from}} to {{MessageDateRange.to}}</span></p>
    <p><strong>Participants:</strong> {{ member.mobile }}</p>

    <div class="form-group filter-row">
      <div class="motors-row form-inline">
        <label>Filter </label>
        <div class="md-form form-sm">
          <input type="date" v-model="filter.from" class="form-control form-control-sm">
        </div>
        <label> To </label>
        <div class="md-form form-sm">
          <input type="date" v-model="filter.to" class="form-control form-control-sm">
        </div>

        <button v-if="status.loading" class="btn btn-sm btn-danger" @click="stopFetchMessage">Stop Loading</button>
        <button v-if="!status.loading && status.next_id > 0" class="btn btn-sm btn-info" @click="startFetchMessage">Load Messages</button>
        <button v-if="!status.loading" class="btn btn-sm btn-success" @click="printRecords">Print</button>
      </div>
    </div>

    <div v-for="msg in Records" class="message" :class="{owner: msg.isOnwer}" :data-id="msg.id">
      <code style="display: none">{{ JSON.stringify(msg) }}</code>
      <span class="phone-number">{{ msg.sender }}</span>
      <span class="timestamp"> 🕒 {{ msg.timestamp }}</span>
      <div class="content">
        <div class="text">
          <p class="inner-text" v-html="whatsappMarkdownToHtml(msg.text)"></p>

          <a v-if="msg.isImage" :href="msg.url"><img
              class="media" :src="msg.url" :alt="msg.filename || `Placeholder Image`" /></a>

          <audio v-if="msg.isAudio" class="media" controls>
            <source :src="msg.url" type="audio/mpeg">
            Your browser does not support the audio element.
          </audio>

          <div v-if="msg.isAudio" class="file">
            <a :href="msg.url" download>Download Audio 🔈</a>
          </div>

          <video v-if="msg.isVideo" class="media" controls>
            <source :src="msg.url" type="video/mp4">
            Your browser does not support the video element.
          </video>

          <div v-if="msg.isVideo" class="file">
            <a :href="msg.url" download>Download Video 🎞️</a>
          </div>

          <div v-if="msg.isFile" class="file">
            <a :href="msg.url" download>🖺 {{msg.filename || `Download File`}}</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MessageServiceClass from "../Services/MsgService"
import UserServiceClass from "../Services/UserService";

const MessageService = new MessageServiceClass();
const UserService = new UserServiceClass();

export default {
  name: "Export",

  data() {
      return {
        status: {
          loading: false,
          next_id: 0,
        },
        message: {
          maxRetries: 999
        },
        filter: {
          from: "",
          to: ""
        },
        member: {
          mobile: "",
          messages: []
        }
      }
  },

  created() {
    this.addBodyClass();
  },

  mounted() {
    document.title = "WhatsApp Chat Record";

    Promise.all([
        this.fetchMemberInfo(),
        this.fetchMessage(),
    ])

    this.initFilter();
  },

  computed: {
    MemberId() {
      return this.$route.params.uid;
    },
    MessageDateRange() {
      let fromDate = '';
      let toDate = '';

      if (this.Records && this.Records.length > 0) {
        fromDate = new Date(this.Records[0].time * 1000).toISOString().split('T')[0];
        toDate = new Date(this.Records[this.Records.length - 1].time * 1000).toISOString().split('T')[0];
      }

      return {
        from: fromDate,
        to: toDate
      };
    },
    Records() {
      let fromTime = 0;
      if (this.filter.from) {
        fromTime = new Date(this.filter.from).getTime() / 1000;
      }
      let toTime = 0;
      if (this.filter.to) {
        toTime = new Date(this.filter.to).getTime() / 1000;
      }

      return this.member.messages
         .filter((row) => {
           return (!fromTime || row.time >= fromTime) && (!toTime || row.time <= toTime);
         })
        .map((row) => {
        const isOnwer = row.to_id == this.MemberId;

        return {
          sender: isOnwer ? "You" : (row.from?.channel_id || ""),
          isOnwer,
          text: row.content?.text || "",
          url: row.content?.url || "",
          isImage: row.type == "image",
          isVideo: row.type == "video",
          isAudio: row.type == "audio",
          isFile: row.type == "file",
          filename: row.content?.filename || "",
          time: row.time,
          timestamp: new Date(row.time * 1000).toLocaleString(),
          id: row.message_id,
        }
      }).sort((a, b) => {
        return a.id - b.id;
      });
    }
  },

  methods: {
    addBodyClass() {
      let classList = (document.body.className || "").split(" ");
      classList = classList.filter((row) => {
        return row && row != "chat-record";
      }).concat(["chat-record"]);

      document.body.className = classList.join(" ");
    },
    removeBodyClass() {
      let classList = (document.body.className || "").split(" ");
      classList = classList.filter((row) => {
        return row && row != "chat-record";
      });

      document.body.className = classList.join(" ");
    },
    initFilter() {
      this.filter.to = (new Date(Date.now() + 86400000)).toISOString().split('T')[0];
    },
    fetchMemberInfo() {
      return UserService.getUser(this.MemberId)
            .then((data) => {
              this.member.mobile = data.channel_id
              return Promise.resolve();
            });
    },
    fetchMessage(nextMsgId = 0) {
      this.status.loading = true;
      return MessageService.getMessages(this.MemberId, nextMsgId)
          .then((data) => {
            this.message.maxRetries--;
            this.member.messages.push(...(data.list || []));
            let {next_id} = data;
            this.status.next_id = next_id;

            if (next_id > 0 && this.message.maxRetries > 0) {
              return this.fetchMessage(next_id);
            }
            return Promise.resolve();
          }).finally(() => {
            this.status.loading = false;
          });
    },
    whatsappMarkdownToHtml(text) {
      // 處理粗體
      text = text.replace(/\*([^*]+)\*/g, '<strong>\$1</strong>');
      // 處理斜體
      text = text.replace(/_([^_]+)_/g, '<em>\$1</em>');
      // 處理刪除線
      text = text.replace(/~([^~]+)~/g, '<del>\$1</del>');
      // 處理等寬字體(代碼塊)
      text = text.replace(/```([^`]+)```/g, '<code>\$1</code>');
      // 處理換行
      text = text.replace(/\n/g, '<br>');

      return text;
    },
    stopFetchMessage() {
      this.message.maxRetries = 0;
    },
    startFetchMessage() {
      this.message.maxRetries = 999;
      if (this.status.next_id > 0) {
        this.fetchMessage(this.status.next_id);
      }
    },
    printRecords() {
      window.print();
    },
  }
}
</script>

<style lang="scss">
@page {
  margin: 0 0 0 0;
  margin-top: 10mm;
}
.chat-record {
  font-size: initial !important;
  font-weight: initial !important;
  font-family: Arial, sans-serif !important;
  line-height: 1.6 !important;
  margin: 0 !important;
  min-height: 100vh !important;
  background-color: #ffffff !important;

  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='220'%3E%3Ctext x='50%25' y='45%25' font-family='Arial, sans-serif' font-size='12' fill='rgba(0,0,0,0.1)' text-anchor='middle' dominant-baseline='middle' transform='rotate(-45 175 100)'%3EFOR INTERNAL USE ONLY%3C/text%3E%3Ctext x='50%25' y='55%25' font-family='Arial, sans-serif' font-size='12' fill='rgba(0,0,0,0.1)' text-anchor='middle' dominant-baseline='middle' transform='rotate(-45 175 100)'%3EDO NOT DISTRIBUTE%3C/text%3E%3C/svg%3E");
  background-repeat: repeat;

  .app-root {
    margin: 0 auto !important;
  }
}

.chat-container {
  margin: 0 auto;
  max-width: 690px;

  .form-inline {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 1em;
  }
}

.message {
  margin-bottom: 15px;
  clear: both;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
  width: 100%;
  display: flow-root;
  text-align: left;

  .phone-number {
    font-weight: bold;
  }

  .timestamp {
    font-size: 0.8em;
    color: #888;
  }

  .content {
    display: block;
    max-width: 100%;
  }

  .text {
    padding: 10px;
    border-radius: 10px;
    display: inline-block;
    max-width: 70%;
    margin: 5px 0;
    word-wrap: break-word;
    background-color: #ffffffad;
    box-shadow: 0 2px 10px rgba(0,0,0,0.22);
    text-align: left;

    .inner-text {
      margin-bottom: 0;
    }
  }

  &.owner {
    text-align: right;

    .text {
      background-color: #a1f56134;
      text-align: left;
    }

    .phone-number,
    .timestamp {
      display: inline-block;
      margin-left: auto;
    }
  }

  .media {
    max-width: 100%;
    height: auto;
    margin: 5px 0;
    border-radius: 5px;
  }

  .file {
    background-color: transparent;
    padding: 5px 0;

    a {
      color: #007bff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
@media (max-width: 768px) {
  .chat-container {
    padding: 1em;
  }
}
@media print {
  .chat-container {
    margin: 0 auto;

    h1 {
      font-size: 2em;
    }

    .filter-row {
      display: none;
    }
  }

  .message {
    page-break-inside: avoid;
  }
}
</style>
